/* eslint-disable react/prop-types */
import './custom.switch.style.css';
const CustomSwitch = ({isToggle,onChangeToggle,style}) => {
    return (
        <label style={style ? style : null} className="switch">
            <input type="checkbox" className="switchInput" checked={isToggle} onChange={onChangeToggle}  />
            <span className="slider">
                <span>Yes</span>
                <span>No</span>
            </span>
        </label>
    )
}

export default CustomSwitch
